<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsSeriesLineChart from './AmChartsSeriesLineChart.vue'
import ChartJsSeriesLineChart from './ChartJsSeriesLineChart.vue'
import type { SeriesLineChartProps } from './types'

/**
 * Several series of the same unit over a **category** axis, one smoothed line each on a
 * shared value axis, with a legend that toggles them. `totalTitle` adds their sum as a
 * heavier line on the same axis, hidden until the legend turns it on. Revenue per day by ad
 * format, and a source's visits against its reported clicks, are the shapes it was built for.
 *
 * `LineChart` and not this for metrics of different units: that one gives every line an
 * axis of its own and spaces points by real dates. This one reads the category as an
 * opaque label, so pass it already formatted and in the order it should run left to right.
 *
 * A line keeps its colour however many there are: hues are spread evenly over the
 * `series` list, so the same list draws the same colours on every render.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsSeriesLineChart.vue` and
 * `AmChartsSeriesLineChart.vue`.
 */
defineProps<SeriesLineChartProps>()

const engine =
  CHART_ENGINE === 'amcharts' ? AmChartsSeriesLineChart : ChartJsSeriesLineChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
